import React from "react";
import { Avatar, Button, Input } from "antd";
import { avatar2, logo } from "../../../commons/PanelImagepath";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../../normalUsers/components/login/AuthPage.css";

const Lockscreen = () => {
  const { t } = useTranslation("dashboard");
  const config = "/";
  return (
    <main className="auth-page auth-page--embedded">
      <div className="auth-page__card">
        <div className="auth-page__brand">
          <img src={logo} alt="LeistFusion" />
        </div>
        <div className="auth-page__body">
          <div className="auth-page__user">
            <Avatar size={72} src={avatar2} alt="" />
            <h2>{t("John Doe")}</h2>
          </div>
          <form className="auth-page__form" action={`${config}admin`}>
            <Input.Password
              size="large"
              autoComplete="current-password"
              placeholder={t("Password")}
              aria-label={t("Password")}
            />
            <Button
              className="auth-page__submit"
              type="primary"
              htmlType="submit"
              size="large"
              block
            >
              {t("Enter")}
            </Button>
          </form>
          <div className="auth-page__switch">
            {t("Sign in as a different user?")} <Link to="/login">{t("Login")}</Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Lockscreen;
